import { ReducersTypes } from "constants/ReducersTypes";

export const initialFilters = {
  page: 1,
  search: "",
  risk_class: "",
  industry: "",
  owner_id: "",
  sort_by: "company_name",
  sort_order: "asc",
};

const initialState = {
  list: [],
  totalCount: 0,
  isFetching: false,
  filters: { ...initialFilters },
};

const creditCustomerList = (state = initialState, action) => {
  switch (action.type) {
    case ReducersTypes.CREDIT_CUSTOMER_LIST:
      return { ...state, ...action.payload };
    case ReducersTypes.CREDIT_CUSTOMER_FILTERS:
      return {
        ...state,
        filters: { ...state.filters, ...action.payload },
      };
    case ReducersTypes.RESET_CREDIT_CUSTOMER_LIST:
      return { ...initialState };
    default:
      return state;
  }
};

export default creditCustomerList;
